import { render, staticRenderFns } from "./OperaCompanyMessageWindow.vue?vue&type=template&id=79dd41ee&scoped=true&"
import script from "./OperaCompanyMessageWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCompanyMessageWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCompanyMessageWindow.vue?vue&type=style&index=0&id=79dd41ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd41ee",
  null
  
)

export default component.exports